module.exports = __webpack_public_path__ + "static/media/smarties.bb236e57.svg";